import { createAction, props } from '@ngrx/store';
import { SuccessStories, SuccessStory } from './state';

export const getSuccessStories = createAction(
  '[API] GET SUCCESSSTORIES',
  props<{ page?: number; pageSize?: number }>()
);
export const getSuccessStoriesSuccess = createAction(
  '[API] GET SUCCESSSTORIES SUCCESS',
  props<{ data: { results: SuccessStories } }>()
);
export const getSuccessStoriesFailure = createAction(
  '[API] GET SUCCESSSTORIES FAILURE',
  props<{ error: string }>()
);

export const addSuccessStories = createAction(
  '[API] ADD SUCCESSSTORIES',
  props<{
    successStory: SuccessStory;
    files: {
      cover_image: any;
      content_images: any;
      video: any;
    };
  }>()
);

export const addSuccessStoriesSuccess = createAction(
  '[API] ADD SUCCESSSTORIES SUCCESS',
  props<{
    successStory: SuccessStory;
  }>()
);

export const addSuccessStoriesError = createAction(
  '[API] ADD SUCCESSSTORIES ERROR',
  props<{ error: string }>()
);

export const updateSuccessStories = createAction(
  '[API] UPDATE SUCCESSSTORIES',
  props<{
    successStory: SuccessStory;
    files: any, 
    id: number;
  }>()
);

export const updateSuccessStoriesSuccess = createAction(
  '[API] UPDATE SUCCESSSTORIES SUCCESS',
  props<{
    successStory: SuccessStory;
  }>()
);

export const updateSuccessStoriesError = createAction(
  '[API] UPDATE SUCCESSSTORIES ERROR',
  props<{ error: string }>()
);

export const getSuccessStoryById = createAction(
  '[API] GET SUCCESSSTORY BY ID',
  props<{ id: number }>()
);
export const getSuccessStoryByIdSuccess = createAction(
  '[API] GET SUCCESSSTORY BY ID SUCCESS',
  props<{ story: SuccessStory }>()
);
export const getSuccessStoryByIdError = createAction(
  '[API] GET SUCCESSSTORY BY ID FAILURE',
  props<{ error: string }>()
);

export const deleteSuccessStory = createAction(
  '[API] DELETE SUCCESSSTORY',
  props<{ id: number }>()
);
export const deleteSuccessStorySuccess = createAction(
  '[API] DELETE SUCCESSSTORY SUCCESS',
  props<{ story: SuccessStory }>()
);
export const deleteSuccessStoryError = createAction(
  '[API] DELETE SUCCESSSTORY FAILURE',
  props<{ error: string }>()
);
